import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextFieldModule } from '@angular/cdk/text-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatTooltipModule,
		MatListModule,
		MatCheckboxModule,
		MatTableModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatIconModule,
		MatSelectModule,
		MatSliderModule,
		MatDividerModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSidenavModule,
		MatSortModule,
		DragDropModule,
		TextFieldModule,
		OverlayModule,
		MatTabsModule,
		MatRippleModule,
	],
	exports: [
		MatTooltipModule,
		MatListModule,
		MatCheckboxModule,
		MatTableModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatIconModule,
		MatSelectModule,
		MatSliderModule,
		MatDividerModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSidenavModule,
		MatSortModule,
		DragDropModule,
		TextFieldModule,
		OverlayModule,
		MatTabsModule,
		MatRippleModule,
	],
})
export class MaterialModule {}
